export default __webpack_public_path__ + "static/media/purple-ball-inverted.8dc9772c.svg";